import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { AuthConfirmationLayout } from '../AuthConfirmationLayout'
import styles from './CreateAccountConfirmation.module.css'

export interface CreateAccountConfirmationProps {
  email: string
  onUseDifferentEmail: () => void
}

export function CreateAccountConfirmation({ email, onUseDifferentEmail }: CreateAccountConfirmationProps) {
  const intl = useIntl()

  return (
    <AuthConfirmationLayout
      icon="Envelope"
      title={intl.formatMessage({ id: 'auth_create_account_confirmation_heading' })}
      afterNote={(
        <Typography as="p" variant="body-s-regular-tight" className={styles.returnMessage}>
          {intl.formatMessage({ id: 'auth_create_account_confirmation_return_prompt' })}
          {' '}
          <Typography
            as="button"
            type="button"
            variant="body-s-regular-tight"
            className={styles.returnButton}
            onClick={onUseDifferentEmail}
          >
            {intl.formatMessage({ id: 'auth_create_account_confirmation_return_action' })}
          </Typography>
        </Typography>
      )}
    >
      <Typography as="p" variant="body-m-regular-snug" className={styles.emailMessage}>
        {intl.formatMessage(
          { id: 'auth_create_account_confirmation_email_message' },
          { email: <Typography as="span" variant="body-m-bold-snug">{email}</Typography> },
        )}
      </Typography>
      <Typography as="p" variant="body-m-regular-snug">
        {intl.formatMessage({ id: 'auth_create_account_confirmation_instructions' })}
      </Typography>
    </AuthConfirmationLayout>
  )
}
